import { useState } from 'react'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import HeroSection from '../../molecules/ArbVenture/HeroSection'
import IntroductionSection from '../../molecules/ArbVenture/IntroductionSection'
import ProblemStatementSection from '../../molecules/ArbVenture/ProblemStatementSection'
import ObjectiveSection from '../../molecules/ArbVenture/ObjectiveSection'
import ApproachSection from '../../molecules/ArbVenture/ApproachSection'
import SolutionSection from '../../molecules/ArbVenture/SolutionSection'
import KeyFeaturesSection from '../../molecules/ArbVenture/KeyFeaturesSection'
import ImpactResultsSection from '../../molecules/ArbVenture/ImpactResultsSection'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'

const ArbVenturePage = () => {
  const [startAnimation, setStartAnimation] = useState(false)

  return (
    <div
      className="relative min-h-screen overflow-x-hidden text-white min-[2560px]:pb-44"
      style={{
        backgroundImage: `linear-gradient(180deg, ${colors.arbVentureHeroBg} 0%, ${colors.arbVentureHeroBg} 52%, ${colors.arbVenturePageBg} 100%)`,
      }}
    >
     <IntroAnimation
  words={['REAL ESTATE', 'PLATFORM']}
  wordColors={['#59892f', '#59892f']}
  backgroundGradient={{
    top: '#282c25',
    bottom: '#282c25',
  }}
  onHeroStart={() => setStartAnimation(true)}
/>

<HeroSection startAnimation={startAnimation} />
      <IntroductionSection />
      <ProblemStatementSection />
      <ObjectiveSection />
      <ApproachSection />
      <SolutionSection />
      <KeyFeaturesSection />
      <ImpactResultsSection />

      <Testimonial showHeader themeColor="arbventure" className="mx-auto mb-20 max-w-[90%]" />

      <div className="w-full">
        <div className="mb-10 px-4 md:px-8 mx-2 lg:mx-20 lg:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_2fr]">
            <Message themeColor="arbventure" />
            <Questions themeColor="arbventure" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ArbVenturePage